import { AlertsAreaId } from '@backoffice-frontend/alerts'
import { AlertsCommonAreaId } from '@backoffice-frontend/alerts-common'
import { AlertsTestingAreaId } from '@backoffice-frontend/alerts-testing'
import { AppAccessControlAreaId } from '@backoffice-frontend/app-access-control'
import { CapacityPlanningAreaId } from '@backoffice-frontend/capacity-planning'
import {
  AccidentsReportsAreaId,
  AccountingAreaId,
  AdConfigurationAreaId,
  AdFleetMapAreaId,
  CouponAreaId,
  CustomerAreaId,
  CustomerFeatureAllowlistingAreaId,
  DisruptionsAreaId,
  DsBossAreaId,
  FleetMapAreaId,
  LegalDocumentManagementAreaId,
  PatternLibraryAreaId,
  SafetyDriverGuidanceAreaId,
  ScLabsAreaId,
  VehicleDeviceManagementAreaId,
  VirtualAdVehiclesAreaId,
} from '@backoffice-frontend/common'
import { DriverTippingAreaId } from '@backoffice-frontend/driver-tipping'
import { EmployeeAreaId } from '@backoffice-frontend/employee'
import { EmployeeTimeManagementAreaId } from '@backoffice-frontend/employee-time-management'
import { FetchAreaId } from '@backoffice-frontend/fetch'
import { FleetMaintenanceAreaId } from '@backoffice-frontend/fleet-maintenance'
import { FleetManagementTestingAreaId } from '@backoffice-frontend/fleet-management-testing'
import { FleetPerformanceOverviewAreaId } from '@backoffice-frontend/fleet-performance-overview'
import { FleetsAreaId } from '@backoffice-frontend/fleets'
import { HubsAreaId } from '@backoffice-frontend/hubs'
import { KpiDashboardAreaId } from '@backoffice-frontend/kpi-dashboard'
import { MobileAppstoreAssetsAreaId } from '@backoffice-frontend/mobile-appstore-assets'
import { OfferAndPoolingAreaId } from '@backoffice-frontend/offer-and-pooling'
import { PassengerAppAreaId } from '@backoffice-frontend/passenger-app'
import { PricingAreaId } from '@backoffice-frontend/pricing'
import { RiderFeedbackAreaId } from '@backoffice-frontend/rider-feedback'
import { RoadNetworkAreaId } from '@backoffice-frontend/road-network'
import { StopNetworkAreaId } from '@backoffice-frontend/sam-common'
import { ServiceBreakLocationsAreaId } from '@backoffice-frontend/service-break-locations'
import { ServiceHoursAreaId } from '@backoffice-frontend/service-hours'
import { ServiceSettingsAreaId } from '@backoffice-frontend/service-settings'
import { ShiftsAreaId } from '@backoffice-frontend/shifts'
import { ShiftsCreationAreaId } from '@backoffice-frontend/shifts-creation'
import { StopNetworkAlertsAreaId } from '@backoffice-frontend/stop-network-alerts'
import { TripAreaId } from '@backoffice-frontend/trip'
import { UserManagementAreaId } from '@backoffice-frontend/user-management'
import { UserManagementOrganizationAreaId } from '@backoffice-frontend/user-management-organization'
import { VehicleAreaId } from '@backoffice-frontend/vehicle'
import { VehicleAlertsAreaId } from '@backoffice-frontend/vehicle-alerts'
import { VehicleGroupAreaId } from '@backoffice-frontend/vehicle-group'
import { useTranslation } from 'react-i18next'
import { DemoRoutesAreaId } from '../../../../../demo-routes/src/lib/DemoRoutesAreaId'
import { MobileAppFlavorConfigAreaId } from '../../../../../mobile-app-flavor-config/src/lib/MobileAppFlavorConfigAreaId'

export const useGetAreaTranslation = () => {
  const { t } = useTranslation()

  const getAreaTranslation = (id: string) => {
    switch (id) {
      case UserManagementAreaId:
        return t('authenticatedAppView_userManagementArea')
      case UserManagementOrganizationAreaId:
        return t('authenticatedAppView_userManagementArea')
      case AlertsAreaId:
        return t('authenticatedAppView_alertsArea')
      case CapacityPlanningAreaId:
        return t('authenticatedAppView_capacityPlanningArea')
      case EmployeeAreaId:
        return t('authenticatedAppView_employeeArea')
      case ShiftsAreaId:
        return t('authenticatedAppView_shiftsArea')
      case DriverTippingAreaId:
        return t('authenticatedAppView_driverTippingArea')
      case EmployeeTimeManagementAreaId:
        return t('authenticatedAppView_employeeTimeManagementArea')
      case VehicleAlertsAreaId:
        return t('authenticatedAppView_vehicleAlertsArea')
      case FleetMaintenanceAreaId:
        return t('authenticatedAppView_fleetMaintenanceArea')
      case VehicleAreaId:
        return t('authenticatedAppView_vehicleArea')
      case FleetMapAreaId:
        return t('authenticatedAppView_fleetMapArea')
      case AdFleetMapAreaId:
        return t('authenticatedAppView_adFleetMapArea')
      case VehicleGroupAreaId:
        return t('authenticatedAppView_vehicleGroupArea')
      case StopNetworkAreaId:
        return t('authenticatedAppView_stopNetworkArea')
      case StopNetworkAlertsAreaId:
        return t('authenticatedAppView_stopNetworkAlertsArea')
      case HubsAreaId:
        return t('authenticatedAppView_hubsArea')
      case ServiceHoursAreaId:
        return t('authenticatedAppView_serviceHoursArea')
      case CustomerAreaId:
        return t('authenticatedAppView_customerArea')
      case TripAreaId:
        return t('authenticatedAppView_tripArea')
      case CouponAreaId:
        return t('authenticatedAppView_couponArea')
      case AdConfigurationAreaId:
        return t('authenticatedAppView_adConfigurationArea')
      case AccountingAreaId:
        return t('authenticatedAppView_accountingArea')
      case PassengerAppAreaId:
        return t('authenticatedAppView_passengerAppArea')
      case PricingAreaId:
        return t('authenticatedAppView_pricingArea')
      case AlertsTestingAreaId:
        return t('authenticatedAppView_alertsTestingArea')
      case PatternLibraryAreaId:
        return t('authenticatedAppView_patternLibraryArea')
      case ShiftsCreationAreaId:
        return t('authenticatedAppView_shiftsCreationArea')
      case FleetManagementTestingAreaId:
        return t('authenticatedAppView_fleetManagementTestingArea')
      case VirtualAdVehiclesAreaId:
        return t('authenticatedAppView_virtualAdVehiclesArea')
      case DsBossAreaId:
        return t('authenticatedAppView_dsBossArea')
      case CustomerFeatureAllowlistingAreaId:
        return t('authenticatedAppView_customerFeatureAllowlistingArea')
      case AccidentsReportsAreaId:
        return t('authenticatedAppView_accidentsReportsArea')
      case SafetyDriverGuidanceAreaId:
        return t('authenticatedAppView_safetyDriverGuidanceArea')
      case DisruptionsAreaId:
        return t('authenticatedAppView_disruptionsArea')
      case FleetsAreaId:
        return t('authenticatedAppView_fleetsArea')
      case OfferAndPoolingAreaId:
        return t('authenticatedAppView_offerAndPoolingArea')
      case ServiceSettingsAreaId:
        return t('authenticatedAppView_serviceSettingsArea')
      case LegalDocumentManagementAreaId:
        return t('authenticatedAppView_legalDocumentManagementArea')
      case FetchAreaId:
        return t('authenticatedAppView_fleetTracingArea')
      case FleetPerformanceOverviewAreaId:
        return t('authenticatedAppView_fleetPerformanceOverviewArea')
      case MobileAppstoreAssetsAreaId:
        return t('authenticatedAppView_mobileAppstoreAssetsArea')
      case RoadNetworkAreaId:
        return t('authenticatedAppView_roadNetworkArea')
      case AppAccessControlAreaId:
        return t('authenticatedAppView_appAccessControlArea')
      case VehicleDeviceManagementAreaId:
        return t('authenticatedAppView_vehicleDeviceManagementArea')
      case DemoRoutesAreaId:
        return t('authenticatedAppView_demoRoutesArea')
      case RiderFeedbackAreaId:
        return t('authenticatedAppView_riderFeedbackArea')
      case ServiceBreakLocationsAreaId:
        return t('authenticatedAppView_serviceBreakLocationsArea')
      case KpiDashboardAreaId:
        return t('authenticatedAppView_serviceKpisSection_navigation')
      case ScLabsAreaId:
        return t('authenticatedAppView_scLabsSection_navigation')
      case AlertsCommonAreaId:
        return t('authenticatedAppView_hscAlerts_navigation')
      case MobileAppFlavorConfigAreaId:
        return t('authenticatedAppView_mobileAppFlavorConfigArea')
      default:
        return id
    }
  }

  return { getAreaTranslation }
}
